import { render, staticRenderFns } from "./TablaComunicados.vue?vue&type=template&id=27684459"
import script from "./TablaComunicados.vue?vue&type=script&lang=js"
export * from "./TablaComunicados.vue?vue&type=script&lang=js"
import style0 from "./TablaComunicados.vue?vue&type=style&index=0&id=27684459&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports